import { Bell } from "lucide-react"
import type { Notification } from "@/lib/notifications-data"
import { NotificationItem } from "./notification-item"

interface NotificationsListProps {
  notifications: Notification[]
  onMarkAsRead?: (id: string) => void
  onActionClick?: (notification: Notification) => void
}

export function NotificationsList({ notifications, onMarkAsRead, onActionClick }: NotificationsListProps) {
  if (notifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="p-4 bg-gray-100 rounded-full mb-4">
          <Bell className="w-8 h-8 text-gray-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No notifications</h3>
        <p className="text-gray-600">You're all caught up! Check back later for new updates.</p>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onActionClick={onActionClick}
        />
      ))}
    </div>
  )
}
